/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createInviteCodes.defs'
export { main as default } from './createInviteCodes.defs'
